/* An invitation only. The existing adviser remains a normal destination link. */
(() => {
 const seenKey='apo-skin-invitation-seen-v1';
 class ApoSkinInvitation extends HTMLElement {
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();
   const on=(target,event,callback)=>target.addEventListener(event,callback,{signal:this.controller.signal});
   this.dialog=this.querySelector('dialog');
   if(!this.dialog?.showModal)return;
   const dialog=this.dialog;
   on(this,'click',event=>{if(event.target.closest('[data-skin-dismiss]'))dialog.close();});
   on(dialog,'click',event=>{
    if(event.target!==dialog)return;
    const box=dialog.getBoundingClientRect();
    if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();
   });
   on(dialog,'close',()=>this.restore());
   on(this.querySelector('[data-skin-destination]'),'click',()=>{try{sessionStorage.setItem(seenKey,'1');}catch{}});
   on(document,'shopify:section:select',event=>{if(event.detail.sectionId===this.dataset.sectionId)this.show();});
   on(document,'shopify:section:deselect',event=>{if(event.detail.sectionId===this.dataset.sectionId)dialog.close();});
   const preview=new URLSearchParams(location.search).get('diagnostic-popup')==='1';
   if(preview){this.show();return;}
   if(this.dataset.designMode==='true')return;
   try{if(sessionStorage.getItem(seenKey)||sessionStorage.getItem('apo-skin-return'))return;}catch{}
   this.timer=setTimeout(()=>this.maybeShow(),Number(this.dataset.delay)*1000);
  }
  visible(element){
   if(!element||element.hidden||element.getAttribute('aria-hidden')==='true')return false;
   const style=getComputedStyle(element);
   return style.display!=='none'&&style.visibility!=='hidden'&&element.getClientRects().length>0;
  }
  maybeShow(){
   // Never compete with consent, navigation, the cart, or another open dialog.
   const occupied=document.hidden||document.querySelector('dialog[open], .menu-drawer-container[open], header-drawer details[open]')||
    [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, [aria-modal="true"], .klaviyo-form')].some(el=>this.visible(el))||
    document.activeElement?.matches('input,textarea,select');
   if(occupied){this.timer=setTimeout(()=>this.maybeShow(),3000);return;}
   try{if(sessionStorage.getItem(seenKey))return;}catch{}
   this.show();
  }
  show(){
   if(this.dialog.open)return;
   clearTimeout(this.timer);
   this.previousFocus=document.activeElement;
   this.scrollPosition=window.scrollY;
   this.previousBodyStyle=document.body.getAttribute('style');
   this.locked=true;
   Object.assign(document.body.style,{position:'fixed',top:`-${this.scrollPosition}px`,width:'100%',overflow:'hidden'});
   this.dialog.showModal();
   try{sessionStorage.setItem(seenKey,'1');}catch{}
   this.querySelector('h2')?.focus({preventScroll:true});
  }
  restore(){
   if(!this.locked)return;
   this.locked=false;
   if(this.previousBodyStyle===null)document.body.removeAttribute('style');
   else document.body.setAttribute('style',this.previousBodyStyle);
   window.scrollTo({top:this.scrollPosition,behavior:'instant'});
   if(this.previousFocus?.isConnected)this.previousFocus.focus({preventScroll:true});
  }
  disconnectedCallback(){
   clearTimeout(this.timer);
   if(this.dialog?.open)this.dialog.close();
   this.restore();
   this.controller?.abort();this.controller=null;
  }
 }
 if(!customElements.get('apo-skin-invitation'))customElements.define('apo-skin-invitation',ApoSkinInvitation);
})();
